import {request} from '@/helpers/apiClient'
import {GROWTHBOOK_CONFIG} from '@/utils/constants/apiConfig/global/growthBook/growthBookConfig'

export const getGrowthBookData = () => request(GROWTHBOOK_CONFIG.GROWTHBOOK_CONFIG, '')
